import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SCREEN_TYPE } from 'utils/enums';

const initialState: CollectionTaskState = {
    screenMode: SCREEN_TYPE.list,
    formSearch: {},
    sort: 'task_id:asc',
    dataTableDetail :[]
};

export const collectionTaskSlice = createSlice({
    name: 'collectionTask',
    initialState,
    reducers: {
        // Common
        setMode: (state, action: PayloadAction<SCREEN_TYPE>) => {
            state.screenMode = action.payload;
        },
        setFormSearch: (state, action: PayloadAction<ICollectionSearch>) => {
            state.formSearch = action.payload;
        },
        setSort: (state, action: PayloadAction<string | undefined>) => {
            state.sort = action.payload;
        },
        setDataTableDetail: (state, action: PayloadAction<ITaskContainer[]>) => {
            state.dataTableDetail = action.payload;
        },
    },
});

export const {
    // Detail
    // List
    // Common
    setFormSearch,
    setMode,
    setSort,
    setDataTableDetail
} = collectionTaskSlice.actions;

export default collectionTaskSlice.reducer;
